<script setup lang="ts">
const blog_id = useRoute()?.params?.blog_id?.toString();

// 初回表示時のページ番号をセット
const route = useRoute();

// 現在のページ番号
const current = computed(() => {
  return route.query.off ? parseInt(route.query.off.toString()) : 0;
});

const { data, pending } = await useFetch(
  () => `/api/blog/${blog_id}?off=${current.value}`,
);

if (data.value && !data.value.blog_name) {
  throw createError({ statusCode: 404, message: "Not Found", fatal: true });
}

if (data.value) {
  useHead({
    title: data.value.blog_name,
    meta: [
      {
        name: "description",
        content: data.value.exp || data.value.blog_name,
      },
    ],
  });
}

useBreadcrumbs([
  { name: "TOP", path: "/" },
  { name: data.value?.blog_name ?? "", path: `/BLOG/${blog_id}` },
]);
useScrollTop(true);
</script>

<template>
  <div v-if="data" class="p-blog wrapper mb-16">
    <TextPageTitle>{{ data.blog_name }}</TextPageTitle>
    <div class="min-h-screen relative max-w-[1024px] mx-auto mb-16">
      <transition name="fade">
        <BlogList :blog_id="blog_id" :list="data?.list" v-if="!pending" />
      </transition>
      <Loading class="absolute left-1/2 -translate-x-5 top-80" v-if="pending" />
    </div>
    <Pagination class="mb-4" :current="current" :max="data.max" />
  </div>
</template>
